import { docReady } from './utils';
import detectorInit from './detector';
import swiperInit from './swiper';
import navbarInit from "./navbar-darken-on-scroll";

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(detectorInit);
docReady(swiperInit);
docReady(navbarInit);

// UDARA (Neon Green Style)
const udaraText = `
██  ██ █████  █████  █████  █████
██  ██ ██  ██ ██  ██ ██  ██ ██  ██
██  ██ ██  ██ ██████ █████  ██████
██  ██ ██  ██ ██  ██ ██  ██ ██  ██
██████ █████  ██  ██ ██  ██ ██  ██
`;

const supunText = `
██████ ██  ██ ██████ ██  ██ ██  ██
██     ██  ██ ██  ██ ██  ██ ███ ██
██████ ██  ██ ██████ ██  ██ ██████
    ██ ██  ██ ██     ██  ██ ██ ███
██████ ██████ ██     ██████ ██  ██
`;

// "UDARA" කොටසට දෙන Neon Green Style එක සහ 3D Outlines
const styleUdara = `
  color: #ccff00;
  font-family: monospace;
  font-weight: bold;
  line-height: 1.2;
  text-shadow:
    2px 2px 0px #222,
    4px 4px 0px #ccff00,
    6px 6px 0px #222,
    8px 8px 0px #ccff00;
`;

// "SUPUN" කොටසට දෙන White Style එක සහ 3D Outlines
const styleSupun = `
  color: #ffffff;
  font-family: monospace;
  font-weight: bold;
  line-height: 1.2;
  text-shadow:
    2px 2px 0px #222,
    4px 4px 0px #ffffff,
    6px 6px 0px #222,
    8px 8px 0px #ffffff;
`;

// Browser Console එකේ Print කිරීම
console.log("%c" + udaraText + "%c" + supunText, styleUdara, styleSupun);


